import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSpaSession, getApiHost } from './utils/api';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Pre-warm the SPA session token
initSpaSession();

// Mobile Safari (and a few others) bfcache the entire page state when
// you switch tabs / put the phone to sleep, then restore it on return.
// In-flight fetches don't survive — the SPA-token Promise can be left
// pending forever, which leaves every loading spinner stuck on
// resume. Detect a bfcache restore (pageshow + event.persisted) and
// hard-reload so the app re-bootstraps cleanly. Cheaper than a long
// chain of "abort + retry" wiring through every fetch site.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

// Pageview beacon — sends page + referrer to API so frontend traffic
// appears in Loki/Grafana alongside API traffic.
try {
  const apiHost = getApiHost();
  const payload = JSON.stringify({
    page: window.location.pathname,
    referrer: document.referrer || null,
  });
  navigator.sendBeacon(`${apiHost}/api/pageview`, new Blob([payload], { type: 'application/json' }));
} catch (_) {
  // Non-critical — never block the app
}
